import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Fri Dec 07 2018
 * @author LZe
 */
import * as React from 'react';
import Icon, { IconColor, IconType } from '../../../../media/Icon';
import Tooltip from '../../../../info/Tooltip';
import { TooltipType } from '../../../../..';
import { Observer } from 'mobx-react';
export var WindowItemWarnRenderer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WindowItemWarnRenderer, _React$Component);

  function WindowItemWarnRenderer() {
    _classCallCheck(this, WindowItemWarnRenderer);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemWarnRenderer).apply(this, arguments));
  }

  _createClass(WindowItemWarnRenderer, [{
    key: "renderIcon",
    value: function renderIcon() {
      return React.createElement("span", {
        className: "ag-icon-left-icon"
      }, React.createElement(Icon, {
        iconType: this.props.iconType,
        iconHeight: 17,
        iconColor: this.props.iconColor
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      if (!this.props.tooltip || this.props.tooltip.length === 0) {
        return this.renderIcon();
      }

      return React.createElement(Observer, null, function () {
        return React.createElement(Tooltip, {
          tooltipType: TooltipType.Info,
          overlay: React.createElement("div", null, _this.props.tooltip.map(function (tooltip) {
            return React.createElement("div", {
              key: tooltip
            }, tooltip);
          })),
          children: _this.renderIcon()
        });
      });
    }
  }]);

  return WindowItemWarnRenderer;
}(React.Component);
WindowItemWarnRenderer.defaultProps = {
  iconType: IconType.alert,
  iconColor: IconColor.Error
};